import { render, staticRenderFns } from "./BannerSpaceBanners.vue?vue&type=template&id=5c322760&"
import script from "./BannerSpaceBanners.vue?vue&type=script&lang=js&"
export * from "./BannerSpaceBanners.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports